import { render, staticRenderFns } from "./drugProtocolSetup.vue?vue&type=template&id=065a4c5a&scoped=true&"
import script from "./drugProtocolSetup.vue?vue&type=script&lang=js&"
export * from "./drugProtocolSetup.vue?vue&type=script&lang=js&"
import style0 from "./drugProtocolSetup.vue?vue&type=style&index=0&id=065a4c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a4c5a",
  null
  
)

export default component.exports